var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEntityUncertainSelected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 48,
  viewBox: "0 -960 960 960",
  width: 48,
  fill: "#F19E39"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M483.45-239.35q17.95 0 30.75-12.67t12.8-30.73q0-18.07-12.73-30.69-12.73-12.63-30.8-12.63-18.06 0-30.74 12.54-12.69 12.53-12.69 30.76 0 17.94 12.65 30.68 12.64 12.74 30.76 12.74ZM442.28-390.2h71.24q0-27.06 6.12-49.45 6.12-22.39 41.45-52.2 30.76-24.28 43.9-50.12 13.14-25.83 13.14-57.79 0-56.31-35.64-89.22-35.63-32.91-95.47-32.91-54.06 0-93.68 26.86-39.62 26.86-57.1 73.65l63.96 24.21q9.47-27.24 30.85-43.88 21.38-16.65 51.47-16.65 30.21 0 50.31 16.88t20.1 44.14q0 21.11-13.11 40.38-13.12 19.26-36.49 39.06-31.81 26.81-46.43 53.54-14.62 26.73-14.62 73.5Zm37.29 327.4q-85.45 0-161.64-32.92-76.2-32.93-132.74-89.47-56.54-56.54-89.47-132.83-32.92-76.3-32.92-161.95 0-86.54 32.98-162.65 32.98-76.12 89.81-132.94 56.83-56.82 132.74-89.35 75.92-32.52 161.17-32.52 86.63 0 163.08 32.5 76.46 32.51 133.04 89.3 56.58 56.8 89.2 133.09 32.61 76.3 32.61 163.08 0 85.77-32.52 161.42-32.53 75.65-89.35 132.46-56.82 56.82-133.05 89.8Q566.28-62.8 479.57-62.8Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 480,
  cy: -480,
  r: 440,
  fill: "#fff",
  fillOpacity: 0.1
})));

export { SvgEntityUncertainSelected as ReactComponent };
export default __webpack_public_path__ + "8ce9a6b91c3f32c248e86a79e1a3c970.svg";